module.exports = __webpack_public_path__ + "img/chlorineResult_premise.61794d6f.svg";